import { Directive, Input } from '@angular/core';

@Directive()
export class ApxAccessibleControlDirective {
    @Input() ariaLabel!: string;
    @Input() ariaLabelledBy!: string;
    @Input() ariaDescribedBy!: string;
}
